import { application } from "./application"
import ThemeController      from "./theme_controller"
import ScrollAnimController from "./scroll_anim_controller"
import MobileMenuController from "./mobile_menu_controller"
import CounterController    from "./counter_controller"
import ToastController      from "./toast_controller"

application.register("theme",       ThemeController)
application.register("scroll-anim", ScrollAnimController)
application.register("mobile-menu", MobileMenuController)
application.register("counter",     CounterController)
application.register("toast",       ToastController)
